import React, {ReactNode} from 'react';
import {Link} from 'react-router';
import {useIsDarkMode} from '@ui/themes/use-is-dark-mode';
import {useSettings} from '@ui/settings/use-settings';
import {useTrans} from '@ui/i18n/use-trans';
import authBgSvg from '@common/auth/ui/auth-layout/auth-bg.svg';

interface Props {
  children: ReactNode;
  wide?: boolean;
}
export function OnboardingLayout({children, wide}: Props) {
  const {branding} = useSettings();
  const isDarkMode = useIsDarkMode();
  const {trans} = useTrans();

  return (
    <main
      className="flex min-h-screen flex-col items-center overflow-y-auto bg-alt px-14 pb-40 pt-40 dark:bg-none"
      style={{backgroundImage: isDarkMode ? undefined : `url("${authBgSvg}")`}}
    >
      <Link
        to="/"
        className="mb-32 block flex-shrink-0"
        aria-label={trans({message: 'Go to homepage'})}
      >
        <img
          src={isDarkMode ? branding.logo_light : branding?.logo_dark}
          className="m-auto block h-42 w-auto"
          alt=""
        />
      </Link>

      <div
        className={`mx-auto w-full rounded-lg bg px-40 pb-40 pt-32 shadow md:shadow-xl ${
          wide ? 'max-w-1000' : 'max-w-440'
        }`}
      >
        {children}
      </div>
    </main>
  );
}
